module.exports = {
    profile: 'Perfil',
    language: 'Idioma',
    security: 'Segurança',
    privacy: 'Privacidades',
    customization: 'Acessibilidade e Customização',
    gamification: 'Gamificação',
}
